import {
  RugbyUnionEventStatusId,
  RugbyUnionIncidentId,
} from '@collector/sportsapi-client-legacy'

import { EventStatusIncidentsOnFieldConfig } from '../../../configuration'

const eventStatusToIncidentIdMap: Map<
  RugbyUnionEventStatusId,
  RugbyUnionIncidentId[]
> = new Map([
  [
    RugbyUnionEventStatusId.NotStarted,
    [
      RugbyUnionIncidentId.MatchAboutToStart,
      RugbyUnionIncidentId.Kickoff,
      RugbyUnionIncidentId.FirstHalf,
    ],
  ],
  [
    RugbyUnionEventStatusId.StartDelayed,
    [
      RugbyUnionIncidentId.MatchAboutToStart,
      RugbyUnionIncidentId.Kickoff,
      RugbyUnionIncidentId.FirstHalf,
    ],
  ],
  [RugbyUnionEventStatusId.Halftime, [RugbyUnionIncidentId.SecondHalf]],
  [
    RugbyUnionEventStatusId.WaitingForExtratime,
    [RugbyUnionIncidentId.ExtratimeFirstHalf],
  ],
  [
    RugbyUnionEventStatusId.ExtratimeHalftime,
    [RugbyUnionIncidentId.ExtratimeSecondHalf],
  ],
  [
    RugbyUnionEventStatusId.WaitingForPenalty,
    [RugbyUnionIncidentId.PenaltiesStarted],
  ],
])

const kickOffIncidentId = RugbyUnionIncidentId.Kickoff
const secondHalfIncidentId = RugbyUnionIncidentId.SecondHalf

export const eventStatusIncidentsOnFieldConfig: EventStatusIncidentsOnFieldConfig =
  {
    eventStatusToIncidentIdMap,
    secondHalfIncidentId,
    startingSide: {
      incidentId: kickOffIncidentId,
      text: 'Which team will KICK-OFF ?',
    },
  }
